/**
 * PhaseStubCard — compact tile for Phases 2–5. Shows the card ID,
 * title, phase badge, and a "LISTENING FOR PHASE 1 HANDOFF" strip so
 * the prospect sees the roadmap without us faking logic we haven't
 * built. Uses the same glass-morphism chrome as the real NDS cards.
 */
import React from "react";
import { Radio, Pencil } from "lucide-react";

export default function PhaseStubCard({ id, title, hint, Icon, editable, onEdit }) {
  return (
    <div
      data-testid={`veroogle-stub-${id.toLowerCase()}`}
      className="glass-card rounded-xl px-4 py-4 flex flex-col gap-3 overflow-hidden group transition-all duration-300 hover:-translate-y-1 relative"
    >
      {editable && (
        <button
          type="button"
          onClick={(e) => { e.stopPropagation(); onEdit?.(); }}
          data-testid={`veroogle-stub-edit-${id.toLowerCase()}`}
          title="Edit card"
          className="absolute top-2 right-2 p-1.5 rounded-md bg-navy-950/80 border border-white/10 text-slate-400 hover:text-brand-cyan hover:border-brand-cyan/60 transition opacity-0 group-hover:opacity-100"
        >
          <Pencil className="w-3 h-3" />
        </button>
      )}
      <div className="flex items-start justify-between gap-3">
        <div className="p-1.5 rounded-lg bg-navy-950 border border-slate-800 text-slate-300 group-hover:border-brand-blue/50 group-hover:text-brand-cyan transition shrink-0">
          {Icon ? <Icon className="w-4 h-4" /> : <Radio className="w-4 h-4" />}
        </div>
        <span className="font-mono text-[9px] tracking-[0.18em] uppercase text-slate-500">
          {id}
        </span>
      </div>
      <div className="min-w-0">
        <div className="font-semibold text-slate-200 text-sm leading-tight group-hover:text-brand-cyan transition">{title}</div>
        {hint && (
          <div className="text-slate-500 text-xs mt-1 leading-snug line-clamp-2">{hint}</div>
        )}
      </div>
      <div className="mt-auto pt-2 border-t border-white/8 flex items-center gap-1.5">
        <span className="font-mono text-[9px] font-bold px-2 py-0.5 rounded uppercase tracking-wider border border-amber-500/40 text-amber-400 bg-amber-500/10 inline-flex items-center gap-1">
          <span className="w-1.5 h-1.5 rounded-full bg-amber-400 animate-pulse" />
          Listening · Phase 1
        </span>
      </div>
    </div>
  );
}
